import { writable } from "svelte/store"

export function initMapSettings(state) {
  return writable({
    getFontSizeRem() {
      const max = 1.2
      const min = 0.3
      const range = max - min
      const xShift = 2.5

      const zoom = this.getZoom()
      const x = zoom ? 1 / zoom : 0

      const y = range / (1 + Math.exp(-(x - xShift))) + min

      return y.toFixed(2)
    },
    getZoom() {
      if (!this.mapWidth) return 0

      return this.viewWidth / this.mapWidth
    },
    isEditing: false,
    isSnapToGridEnabled: true,
    mapWidth: 0,
    storageUnitTextFontSizeRem: "0.75",
    viewWidth: 0,
    ...state,
  })
}

export function initUpdateMapSettings(store) {
  return (settings) => {
    store.update((current) => ({ ...current, ...settings }))
    store.update((current) => ({
      ...current,
      storageUnitTextFontSizeRem: current.getFontSizeRem(),
    }))
  }
}

export function toRadians(degrees) {
  return (degrees * Math.PI) / 180
}

export function throttleScrollDelta(event, to = 10) {
  const from = event.deltaY

  if (from === 0) return 0

  const isTrackPad = Math.abs(from) < 50 && event.deltaMode === 0

  if (isTrackPad) return from

  const sign = from / Math.abs(from)

  let out = from
  out = Math.abs(out)
  out = Math.min(out, to)
  out = Math.max(out, 1)
  out = isNaN(out) ? 1 : out
  out = sign * out

  return out
}
